module.exports = "/_next/static/images/WebFirstIntroduce-85e055cfbd088e5007a0e7d02af427cb.png";